import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
import { AppService } from '../app/app.service';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  private url = GlobalService.serverURL;
  userInfo: any;

  constructor(private http: HttpClient, private appService: AppService) {
    // this.userInfo = JSON.parse(localStorage.getItem('training-portal.userInfo'));
    this.userInfo = this.appService.getData('training-portal.userInfo')
  }
  downloadCert(data){
    return this.http.post(this.url + 'test/download_all_cert', data, { headers });
  }
  onBoardCompany = (data: any): any => {
    return this.http.post(this.url + 'company/company_onboard/onboard', data, { headers })
  }
  // managerList = (pageSize: any, start: any): any => {
  //   return this.http.get(this.url + 'manager/Listing?pageSize=' + pageSize + '&start=' + start, { headers }).toPromise();
  // }
  // empList = (pageSize: any, start: any): any => {
  //   return this.http.get(this.url + 'employee/team/listing?pageSize=' + pageSize + '&start=' + start, { headers }).toPromise();
  // }
  //   recruiterList = (pageSize: any, start: any): any => {
  // return this.http.get(this.url + 'recruiter/listing?pageSize=' + pageSize + '&start=' + start, { headers }).toPromise();
  // }
  managerList = (data: any): any => {
    return this.http.post(this.url + 'manager/Listing', data, { headers })
  }
  assignEmp = (data: any): any => {
    return this.http.post(this.url + 'manager/assign_user_manager/assign_employee_to_manager_list', data, { headers })
  }
  assignManager = (data: any): any => {
    return this.http.post(this.url + 'manager/assign_user_manager/assign_manager_to_employee_list', data, { headers })
  }
  managerListAll = (): any => {
    return this.http.get(this.url + 'manager/Listing/manager', { headers })
  }
  empList = (data: any): any => {
    return this.http.post(this.url + 'employee/team/listing', data, { headers })
  }
  empListNew = (data: any): any => {
    return this.http.post(this.url + 'employee/team/listing/comp_emp_list', data, { headers })
  }
  addUser = (data: any): any => {
    return this.http.post(this.url + 'company/add_user/add_new_user', data, { headers })
  }
  managerAccessDetails = (data: any): any => {
    return this.http.post(this.url + 'company/add_user/manager_access_details', data, { headers })
  }
  addEmp = (data: any): any => {
    return this.http.post(this.url + 'employee/team/invite', data, { headers })
  }
  recruiterList = (data: any): any => {
    return this.http.post(this.url + 'recruiter/listing', data, { headers })
  }
  sendInvitationRecruiter = (data: any): any => {
    return this.http.post(this.url + 'recruiter/job/job_candidate_list_company', data, { headers })
  }
  // https://univate.ie/new_demo/api/company/delete_user?usertype=employee&id=37&employee_id=1411&email=kylascheck88@gmail.com
  deleteUser = (usertype: any, id: any, data: any): any => {
    return this.http.get(this.url + 'company/delete_user?usertype=' + usertype + '&id=' + id + data, { headers });
  }

  departmentListing(data) {
    return this.http.post(this.url + 'company/manage_department/listing', data, { headers })
  }

  exportCSV = (data: {}): any => {
    return this.http.post(this.url + 'company/export_csv', data, { headers });
  }
  importEmployeeCSV = (data: {}): any => {
    return this.http.post(this.url + 'company/import_user/employee', data, { headers });
  }
  imporManagerCSV = (data: {}): any => {
    return this.http.post(this.url + 'company/import_user', data, { headers });
  }
  editManager = (data: {}): any => {
    return this.http.post(this.url + 'manager/edit', data, { headers });
  }
  editEmployee = (data: {}): any => {
    return this.http.post(this.url + 'employee/team/edit', data, { headers })
  }
  changeCoursePractical(data: {}) {
    return this.http.post(this.url + 'employee/team/change_status/course_practical', data, { headers });
  }

  changeCourseManual(data: {}) {
    return this.http.post(this.url + 'employee/team/change_status/manual_certificate_practical', data, { headers })
  }
  assignCourseDelete(data: any) {
    return this.http.post(this.url + 'employee/team/assign_course/delete', data, { headers })
  }
  viewExamSheet(data: any) {
    return this.http.post(this.url + 'manager/employee_list/exam_list', data, { headers })
  }
  checkCSV(data) {
    return this.http.post(this.url + 'company/add_user/check_csv', data, { headers });
  }

  testUrl(data) {
    return this.http.post(this.url + 'test/download_awsfile', data, { headers });
  }
  forgotPassword(data) {
    return this.http.post(this.url + 'user/forgot_password', data, { headers })
  }
  editUserProfile(data) {
    return this.http.post(this.url + 'user/edit_profile', data, { headers });
  }
  viewDoc(data) {
    return this.http.post(this.url + 'user/download_url/view', data, { headers })
  }
  acceptTermsCommission(data) {
    return this.http.post(this.url + 'user/login/accep_term', data, { headers })
  }

  companyDashboard(data) {
    return this.http.post(this.url + 'company/dashboard', data, { headers })
  }
  nextMonthExpDashboardData(data) {
    return this.http.post(this.url + 'company/dashboard/expire_data', data, { headers })
  }
  filterManagerStatistic(data) {
    return this.http.post(this.url + 'company/dashboard/filter_manager_statistic', data, { headers });
  }
  filterEmployeeStatistic(data) {
    return this.http.post(this.url + 'company/dashboard/filter_employee_statistic', data, { headers });
  }
  filterCourseStatistic(data) {
    return this.http.post(this.url + 'company/dashboard/filter_course_statistic', data, { headers })
  }
  filterCourseCompleteStatistic = (data): any => {
    return this.http.post(this.url + 'company/dashboard/com_pen', data, { headers });
  }
  getDashboardData(data){
    return this.http.post(this.url + 'company/dashboard/pagination', data, { headers });
  }
}

